import { getStrings } from '../Common/Localization/commonStrings';

const localizedStrings = {
    GeneralSettings: {
        strings: {
          en: {
            profileSettingsLabel: 'PROFILE SETTINGS',
            generalLabel: 'General',
            editBtn: 'Edit',
            nameLabel: 'Name',
            editNameLabel: 'Edit Name',
            firstName: 'First Name',
            lastName: 'Last Name',
            save: 'Save',
            cancel: 'Cancel',
            emailLabel: 'Log In Email',
            editEmailLabel: 'Edit Log In Email',
            passwordLabel: 'Password',
            editPasswordLabel: 'Edit Password',
            oldPasswordLabel:'Old Password',
            newPasswordLabel: 'New Password',
            verifyPasswordLabel: 'Verify New Password',
            newPasswordErrorMessage: 'Your new password must be different from your current password. Please choose a new password.',
            languageLabel: 'Website Language',
            saveError: 'Something went wrong on our end. Please try again.',
            emailsaveError: 'Please use a different email address. This domain isn’t supported.',
            errLink: "<a href='/customer-service-center/help-center/my-account/registering-your-account/blocked-domains'>Learn more</a>",
            editLanguageLabel: 'Edit Website Language',
            langDropDownErrorMsg: 'Please select a language',
            languagePopupInfo: 'You may choose to set a preferred language for SCE.com. When content is available in your preferred language, it will be displayed based on this setting; otherwise, content in English will be displayed.',
            pendingVerficationError: 'This email address is already pending verification.',
            emailAlreadyRegisteredError: 'This email address is already registered with SCE.com by another user.',
            pendingVerificationMsg1: 'A verification email has been sent to your updated email address at ',
            pendingVerificationMsg2: '. To complete the update, please follow the instructions in the email within 24 hours or the update will be canceled.',
            linkExpiredErrMsg: 'Sorry, your email verification link has expired.',
            invalidActivationErrMsg: 'Sorry, your email verification link has expired or the email address has already been added to your profile.',
            logIntoAcctMsg: 'Log in to your account to update your email.',
            verifiedEmailHeader: 'Thanks for verifying your email.',
            updatedEmailMsg: 'Your log-in email has been updated to',
            logIn: 'Log In',
            updateAddrLabel:'Mailing Address',
            updateAddrInfo:'Update your default mailing address to receive your latest US mail communications.',
            updateAddrLink:'Update Mailing Address',
          },
          es: {
          }
        },
        common: ['globalError']
      },
    NotificationSettings: {
        strings: {
          en: {
            notificationLabel: 'Contacts for Notifications',
        description: 'Add, edit, or delete your emails and phone numbers for notifications.',
        email:'Email',
        text:'Text',
        voice:'Voice',
        phone:'Phone',
        mobile:'  (mobile)',
        landline:'  (landline)',
        addemail:'Add email',
        addPhone: 'Add phone',
        verifyPhone: 'Verify this number',
        verifyEmail:'Verify this email',
        manage:'Manage Account',
        delete:'If you no longer wish to have online access to your SCE energy accounts, you can delete your SCE.com User ID.',
        deleteId: 'Delete My SCE.com User ID',
        viewAll: 'View All',
        editBtn: 'Edit',
        viewall:'View All',
        CancelButtonValue:'Cancel',
        SaveButtonValue:'Save',
        AddButtonValue:'Add',
        emailExistsErr:'Email id already exists. Please enter a valid email address.',
        lessThanMsg1:'This contact is receiving',
        alerts:'alerts.',
        lessThanMsg2:'Saving will automatically update all preferences using this contact.',
        greaterThanMsg:'This contact is receiving notification alerts. Saving will automatically update all preferences using this contact',
        errorMsg:'Something went wrong on our end. Please try again.',
        deleteErrMsg:'This Contact is receiving',
        deleteErrMsg2: '. Deleting means recipient will no longer receive ',
        deleteErrMsg3:', and will be removed from our database.',
        deleteErrMsg4:'There must be one emergency contact for your service address. Please ensure another person has enrolled to receive emergency notifications before unenrolling.',
        textExistMsg:'Phone number already exists. Please enter a valid phone number.',
        viewAllEmailTitle:'View All Email Contacts',
        invalidMsg:'Please enter a valid phone number',
        invalidEmailMsg:'Please enter a valid email address',
        msCallErrMsge:'Sorry, we can\'t retrieve your Contacts for Notifications.',
        viewAllVoiceTitle:'View All Voice Contacts',
        viewAllTextTitle:'View All Text Contacts',
        viewAllPhoneTitle:'View All Phone Contacts',
        emailEdit: 'emailPreference',
        voiceEdit: 'voicePreference',
        textEdit: 'textPreference',
        deleteButtonValue: 'Delete',
        mobileRadio:'Mobile',
        landlineRadio:'Landline',
        infoPopupText:'If you need to change the phone type to either a landline or mobile, please delete the number and re-add it to your preference.'
      },
          es: {
          }
        },
        common: ['globalError']
      },
    ManageAccount: {
        strings: {
          en: {
            manageAccLabel:'Manage Account',
            manageAccInfo:'If you no longer wish to have online access to your SCE energy accounts, you can deactivate your SCE.com User ID.',
            deleteIdLink: 'Deactivate My SCE.com User ID',
            deActivatePopupError: 'Something went wrong on our end. Please try again.',
            deactivatePopupHeading: 'Deactivate Your SCE.com Online Access',
            beforeDeactivationSingleAcctMsg: 'Before deactivating your user ID and canceling online access, please deselect enrollment from any program or notification/alert preference. Preferences left on will remain active and your participation will continue unchanged. If later you wish to discontinue participation in any program, or in receiving any notifications or alerts, please contact customer service for assistance.',
            beforeDeactivationMultiAcctMsg: 'Before deactivating your SCE.com online account access, please unenroll from any program in which you are currently enrolled (e.g. Auto Pay), or alert preference to which you are currently subscribed. Unenrolling after account deactivation will require contacting customer service to discontinue your participation.',
            autoPay: 'Auto Pay',
            paperlessBilling: 'Paperless Billing',
            outageAlertsRm: 'Repair and Maintenance Alerts',
            outageAlertsEa: 'Emergency Alerts',
            budgetAssistantAlerts: 'Budget Assistant Notifications',
            cppAlerts: 'Critical Peak Pricing Notifications',
            checkBoxInfo: 'I understand that I am deactivating my SCE.com user ID, and that I will no longer have online account access to SCE.com.',
            deactivateBtn: 'Yes, Deactivate my user ID',
            cancel: 'Cancel',
            turnOffError:'Something went wrong on our end.',
            clickReSubmitText:'Click here to resubmit.',
            enrolledAccounts: 'enrolled accounts',
            viewEditBtn: 'View/Edit',
            viewEditBack: '< Back',
            viewEditheading: ': Turn off alerts for any enrolled accounts',
            viewEditSelectAll: 'Select all enrolled accounts',
            viewEditAcct: ' - Acct. ',
            viewEditTurnOffAlerts: 'Turn Off Alerts',
            requestInQueue: 'Request in queue. Alert will be turned off upon deactivating user ID below.'
          },
          es: {
          }
        },
        common: ['globalError']
      },
    LoginPopup: {
        strings: {
          en:{
            userIdPlaceHolder: 'User ID / Email',
            passwordPlaceHolder: 'Password',
            forgotPassword: 'Forgot your password?',
            resetPassword: 'Reset Password',
            loginButton: 'Log In and Continue',
            rateloginGlobalError: "We're sorry the username or password you entered does not match our records. Please re-enter your information and try again. If you continue to have issues, please try to \
            <a style='text-decoration:underline;' href='/user-registration'> Register </a>\
            your account or \
            <a style='text-decoration:underline;' href='/mysce/resetpassword'>Reset your Password.</a>",
            ratelockedUser: 'For your security, we have locked your account due to too many attempts to Log In. Please contact SCE Customer Service at 1-800-284-2365.',
            loginGlobalError: "We're sorry the username or password you entered does not match our records. Please re-enter your information and try again. If you continue to have issues, please try to \
            <a style='text-decoration:underline;' href='/user-registration'> Register </a>\
            your account or \
            <a style='text-decoration:underline;' href='/mysce/resetpassword'>Reset your Password.</a>",
            lockedUser: 'For your security, we have locked your account due to too many attempts to Log In. Please contact SCE Customer Service at 1-800-284-2365.',
            isCsrErrorMsg: 'We do not recognize the SCE.com User ID entered. Please contact us at 1-800-655-4555 to reset your password.',
            isPwdChanged: 'isPwdChanged',
            payNowLink: "<a href='/apps/ssop'>Pay Now</a>",
            logging: 'Logging In...',
            headerMessage: 'To access your account, please log in with your new password.',
            userName:'userName',
            passWord:'password',
            closeButton: 'Close X',
          }
        }
      }
};
export const getLocalizedStrings = (componentName) => {
    app.logger.getLogger().debug("Comp Name" + componentName);
    var strings = getStrings(localizedStrings[componentName].strings,
      localizedStrings[componentName].common, true);
    return strings;
  };
